import { render, staticRenderFns } from "./books-shelf.vue?vue&type=template&id=44c36d22&scoped=true&"
import script from "./books-shelf.vue?vue&type=script&lang=js&"
export * from "./books-shelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c36d22",
  null
  
)

export default component.exports